import Soknader from "./Soknader";

function SoknaderLayout(){
    return (

            <Soknader></Soknader>

    );
}

export default SoknaderLayout;